import React from 'react'
import { Button, Space } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import { useFetchTextAssignmentSubmissionsQuery } from '../../../../../store/apis/submission.api'
import { useParams } from 'react-router'
import { useTextSubmissionNavigation } from '../../../../../store/apis/utils/hooks/text-submission.hooks'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import useShortcuts from './useShortcuts'

const TextSubmissionDrawerNavigation = () => {
    const { token } = useParams()
    const versionId = useVersionId()
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const { data: submissions } = useFetchTextAssignmentSubmissionsQuery({ token, versionId })

    const { navigateToPreviousSubmission, navigateToNextSubmission, previousSubmissionExists, nextSubmissionExists } =
        useTextSubmissionNavigation()

    useShortcuts(submissions, openedSubmissionId, navigateToPreviousSubmission, navigateToNextSubmission)

    return (
        <Space.Compact size={8}>
            <Button
                icon={<LeftOutlined />}
                onClick={navigateToPreviousSubmission}
                title='Previous submission'
                disabled={!previousSubmissionExists}
            />
            <Button
                icon={<RightOutlined />}
                onClick={navigateToNextSubmission}
                title='Next submission'
                disabled={!nextSubmissionExists}
            />
        </Space.Compact>
    )
}

export default TextSubmissionDrawerNavigation
